const Textarea = ({
    value,
    onChange,
    name,
    placeholder,
    className,
    width = "w-full",
    ...props
}) => {
    const handleChange = (e) => {
        let newValue = e.target.value;
        onChange(name, newValue);
    };

    return (
        <textarea
            type="text"
            id={name}
            name={name}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            className={`${width} px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 ${className}`}
            {...props}
        />
    );
};
export default Textarea;
